import { cloneDeep, treeMap } from '@/utils/tools'
import { Button, Dropdown, Menu, Tree } from '@arco-design/web-react'
import { IconMoreVertical } from '@arco-design/web-react/icon'
import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useRef,
  useEffect,
} from 'react'
const defaultFielaNames = {
  key: 'key',
  children: 'children',
  title: 'title',
  disabled: 'disabled',
}
export const CommonTree = forwardRef(
  (
    {
      children,
      items,
      menu,
      getMenu,
      onActive,
      checkItems,
      onCheckChange,
      checkStrictly = false, //是否取消父子节点关系
      autoExpandParent = true,
      fieldNames = defaultFielaNames,
      renderExtra,
      actionType,
      style = {},
      resetExpandedOnItemsChange = true,
      resetExpandedTrigger,
      resetExpandedToRoot = false,
    },
    ref
  ) => {
    const [selectedKeys, setSelectedKeys] = useState([])
    const [expanded, setExpanded] = useState([])
    const [treeData, setTreeData] = useState([])
    const getItemKey = (item) => {
      return item?.[fieldNames?.key || defaultFielaNames.key] ?? item?.key
    }
    const getItemChildren = (item) => {
      return item?.[fieldNames?.children || defaultFielaNames.children] || []
    }
    const getRootKeys = (treeItems) => {
      return (treeItems || [])
        .map((item) => getItemKey(item))
        .filter((key) => key !== undefined && key !== null)
    }
    const pendingResetExpandedRef = useRef(false)
    const resetExpanded = (treeItems = items) => {
      setExpanded(resetExpandedToRoot ? getRootKeys(treeItems) : [])
      setSelectedKeys([])
    }
    const filterExistingKeys = (keys, treeItems) => {
      const keySet = new Set()
      const collectKeys = (itemList) => {
        itemList?.forEach((item) => {
          const itemKey = getItemKey(item)
          if (itemKey) keySet.add(itemKey)
          collectKeys(getItemChildren(item))
        })
      }
      collectKeys(treeItems)
      return (keys || []).filter((key) => keySet.has(key))
    }
    useEffect(() => {
      if (items) {
        const treedata = treeMap(cloneDeep(items), (item, index) => {
          return {
            ...item,
            title: getTitle(
              item,
              item[fieldNames?.title],
              getMenu ? getMenu(item) : menu
            ),
          }
        })
        setTreeData(treedata)
      } else {
        setTreeData([])
      }
      if (resetExpandedOnItemsChange) {
        resetExpanded(items)
      } else if (
        pendingResetExpandedRef.current &&
        (!resetExpandedToRoot || items?.length > 0)
      ) {
        resetExpanded(items)
        pendingResetExpandedRef.current = false
      } else {
        setExpanded((keys) => filterExistingKeys(keys, items))
        setSelectedKeys((keys) => filterExistingKeys(keys, items))
      }
    }, [items])
    useEffect(() => {
      if (resetExpandedTrigger === undefined) return
      pendingResetExpandedRef.current = true
      if (!resetExpandedToRoot || items?.length > 0) {
        resetExpanded(items)
        pendingResetExpandedRef.current = false
      }
    }, [resetExpandedTrigger])

    const getTitle = (itm, title, mnu) => {
      return (
        <div>
          <div>{title}</div>
          <div>
            {mnu && (
              <div>
                <Dropdown
                  position="br"
                  droplist={
                    <Menu>
                      {mnu?.map((m, midx) => (
                        <Menu.Item
                          key={'ddbot_' + midx}
                          onClick={() => {
                            // let itm = findItem(key);
                            m.onClick && m.onClick(itm)
                          }}
                          disabled={m.disabled}
                        >
                          <span style={{ color: m.color }}>{m.title}</span>
                        </Menu.Item>
                      ))}
                    </Menu>
                  }
                >
                  <Button
                    shape="circle"
                    type="text"
                    icon={<IconMoreVertical />}
                  />
                </Dropdown>
              </div>
            )}
          </div>
        </div>
      )
    }
    const expandRoot = () => {
      const newExpanded = getRootKeys(items)
      setExpanded(Array.from(new Set([...expanded, ...newExpanded])))
    }
    const _setItemId = (item, itemIds) => {
      const itemChildren = getItemChildren(item)
      if (itemChildren && itemChildren.length > 0) {
        itemIds.push(getItemKey(item))
        itemChildren.forEach((c) => {
          _setItemId(c, itemIds)
        })
      }
    }

    const expandAll = () => {
      let newExpanded = []
      items.forEach((c) => {
        _setItemId(c, newExpanded)
      })
      setExpanded(Array.from(new Set([...expanded, ...newExpanded])))
    }
    const findItem = (key) => {
      const _findItem = (_key, _item) => {
        if (getItemKey(_item) === _key) return _item
        const itemChildren = getItemChildren(_item)
        if (!itemChildren) return null
        for (let i = 0; i < itemChildren.length; i++) {
          let itmF = _findItem(_key, itemChildren[i])
          if (itmF) {
            return itmF
          }
        }
        return null
      }
      return _findItem(key, { key: '0', children: items })
    }

    useImperativeHandle(ref, () => ({
      expandAll,
      expandRoot,
      setSelectedKeys,
    }))
    return (
      <>
        <Tree
          style={style}
          actionOnClick={actionType}
          size="large"
          blockNode={true}
          autoExpandParent={autoExpandParent}
          checkStrictly={checkStrictly}
          checkable={!!checkItems}
          checkedKeys={checkItems}
          multiple={false}
          selectedKeys={selectedKeys}
          expandedKeys={expanded}
          onSelect={(keys, extra) => {
            setSelectedKeys(keys)
            const itm = findItem(keys[0])
            onActive && onActive(itm)
          }}
          onCheck={(keys, extra) => {
            onCheckChange && onCheckChange(keys, extra)
          }}
          onExpand={(keys, extra) => {
            setExpanded(keys)
          }}
          fieldNames={fieldNames}
          treeData={treeData}
          renderExtra={renderExtra}
        ></Tree>
      </>
    )
  }
)
